import { routes } from '@/app/routing/router'
import { ConnectPlatformView } from './view'

const currentRoute = routes.connectPlatform

const ConnectPlatformRoute = {
  route: currentRoute,
  view: ConnectPlatformView,
}

export { currentRoute, ConnectPlatformRoute }
